import React, { Suspense } from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import ExcelUploaderSkeleton from './ExcelUploaderSceleton'
import ExcelUploader from './ExcelUploader'
import { useInstitution } from '../../../auth/InstitutionContext'

// Wonde and ClassLink schools get their users from the nightly sync, so the
// Excel upload engine must not run for them. ManagementHeader already hides the
// Upload button, but the route was still reachable and those schools landed on
// the preview step with an "Excel File Not Stored" error.
function SisManagedNotice() {
    const { t } = useTranslation()
    const history = useHistory()

    return (
        <div className="my-[42px] mx-8">
            <div className="bg-white rounded-[32px] py-[52px] px-[48px] shadow-[0px_12px_30px_rgba(45,43,69,0.02)] max-w-[1464px] mx-auto text-center">
                <h2 className="text-[31px] leading-[39px] tracking-tight font-bold text-darkPurple">{t('School Data Upload Not Available')}</h2>
                <p className="text-darkPurple text-[16px] leading-[23px] font-medium mt-4">
                    {t('Your school data is synchronised automatically through your MIS integration, so no Excel upload is needed.')}
                </p>
                <button
                    onClick={() => history.push('/management')}
                    className="mt-8 inline-flex items-center px-6 h-[50px] bg-deepPurple hover:bg-highlightColor rounded-full text-highlightColor hover:text-deepPurple text-[16px] leading-5 font-semibold transition-all duration-300"
                >
                    {t('Back to Management')}
                </button>
            </div>
        </div>
    )
}

function UploadEngineScreen() {
    const { institution } = useInstitution()
    // The context starts as {} and is filled by NavBar/SideBar, so on a direct
    // visit the integration flags aren't known yet; don't mount the uploader
    // until they are.
    const institutionLoaded = !!institution?.id
    const isSisManaged = !!institution?.classlinkConfig?.active || !!institution?.wondeConfig?.active

    return (
        <main className="flex-grow bg-whiteContrast">
            <div className=" mx-auto  ">
                <div className="overflow-hidden">
                    {!institutionLoaded ? (
                        <ExcelUploaderSkeleton />
                    ) : isSisManaged ? (
                        <SisManagedNotice />
                    ) : (
                        <Suspense fallback={<ExcelUploaderSkeleton />}>
                            <ExcelUploader />
                        </Suspense>
                    )}
                </div>
            </div>
        </main>
    )
}

export default UploadEngineScreen
